import { Compass, GraduationCap } from "lucide-react";
import { CtaButton } from "@/components/CtaButton";

export const RecommendationCard = ({ item, rank }) => {
  const Icon = item.type === "journey" ? Compass : GraduationCap;
  return (
    <div className="fea-rec-card" data-testid={`recommendation-${rank}`}>
      <div className="flex items-start gap-4">
        <span className="fea-icon-badge"><Icon className="h-5 w-5" /></span>
        <div className="flex-1">
          <p className="fea-overline">{item.type === "journey" ? "Recommended Journey" : `Recommended Course ${rank}`}</p>
          <h3 className="font-serif text-2xl sm:text-3xl text-[#800534] mt-2" data-testid={`recommendation-${rank}-name`}>{item.name}</h3>
        </div>
      </div>
      <p className="fea-body mt-5">{item.description}</p>
      <p className="fea-body mt-4 text-[#3B121A]">{item.why}</p>
      {item.payment_note && <p className="text-sm text-[#800534] bg-[#FDF2F4] rounded-xl px-4 py-3 mt-4" data-testid={`recommendation-${rank}-payment-note`}>{item.payment_note}</p>}
      {item.cta && <div className="mt-6"><CtaButton cta={item.cta} testId={`recommendation-${rank}-cta`} /></div>}
    </div>
  );
};
